export function salonjobsFormatGraphValue(
  value: string | null | undefined,
  unit: string | null | undefined,
): string {
  const v = value ?? "";
  const u = unit ?? "";
  if (!v || !u || v.endsWith(u)) return v;
  return `${v}${u}`;
}
